module.exports = __webpack_public_path__ + "img/logo-cee.1a7115b4.png";